import React from 'react';
import { Button } from 'react-bootstrap';
import IncompleteCommentPopUp from 'areas/admin/certification/shared/IncompleteCommentPopUp';
import * as APIRoutes from 'modules/app/API';
import API from 'fw/system/API';
import * as Notifications from 'fw/globals/Notifications';
import * as App from 'modules/app/App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft, faArrowCircleRight, faTimesCircle, faSave } from '@fortawesome/free-solid-svg-icons'
import { ReviewType } from 'areas/shared/consts';

class AdminStepToolbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            showPopUp: false
        };
    }

    showPopUp = () => {
        this.setState({
            showPopUp: true
        });
    }

    handleSave = () => {
        if (this.props.onSave)
            this.props.onSave();
    }

    handleCancel = () => {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    onCommentSave = (form) => {
        if (!this.props.onCommentSave)
            return;

        if (form) {
            this.props.onCommentSave(form, this.state.callback);
        }
        else
            this.props.onCommentSave(null, this.state.callback);
    }

    checkReviewStatus = (callback) => {
        const me = this;
        const context = App.context();

        const isIncompleteType = (comment) => comment.commentTypeCode === "INC" &&
            comment.reviewTypeCode === this.props.reviewTypeCode && comment.queueTypeCode === this.props.queueTypeCode &&
            (this.props.queueTypeCode !== "COM" || (this.props.queueTypeCode === "COM" && comment.addedBy === context.userName));

        const isCompleteType = (comment) => comment.commentTypeCode === "COM" &&
            comment.reviewTypeCode === this.props.reviewTypeCode && comment.queueTypeCode === this.props.queueTypeCode &&
            (this.props.queueTypeCode !== "COM" || (this.props.queueTypeCode === "COM" && comment.addedBy === context.userName));

        this.setState({ callback: callback });

        if (this.props.reviewStatus !== null && !this.props.reviewStatus
            && this.props.comments && !this.props.comments.some(isIncompleteType)) {
            me.showPopUp();
        }
        else if (this.props.reviewStatus !== null && this.props.reviewStatus
            && this.props.comments && !this.props.comments.some(isCompleteType)) {
            me.addCompleteComment(callback);
        }
        else {
            callback();
        }
    }

    urls() {
        return {
            addComment: APIRoutes.Admin.url('/comment/addComment')
        }
    }

    addCompleteComment = (callback) => {
        const me = this;
        const rq = {
            certificationKey: this.props.certificationKey,
            reviewTypeCode: this.props.reviewTypeCode,
            queueTypeCode: this.props.queueTypeCode,
            commentTypeCode: "COM",
            content: "<b class='text-success'>Complete</b>"
        };
        const url = this.urls().addComment;

        let comments = null;
        if (this.props.comments)
            comments = this.props.comments;

        new API().post(url, rq, {
            success: (r) => {
                if (comments) {
                    comments.unshift({
                        commentId: r.data.commentId,
                        reviewTypeDescription: r.data.reviewTypeDescription,
                        reviewTypeCode: r.data.reviewTypeCode,
                        queueTypeCode: r.data.queueTypeCode,
                        queueTypeDescription: r.data.queueTypeDescription,
                        commentTypeCode: r.data.commentTypeCode,
                        content: r.data.content,
                        addedDate: r.data.addedAt,
                        addedBy: r.data.addedBy
                    });
                }

                this.setState({
                    saving: false,
                    form: {
                        ...this.state.form,
                        ...r.data,
                        comments: comments,
                        original: {
                            ...this.state.form,
                            ...r.data
                        }
                    }
                }, () => {
                    if (me.props.onCommentSave)
                        me.props.onCommentSave(me.state.form, callback);
                });
            },
            error: r => {
                me.setState({ saving: false });
                Notifications.error(r.error.errorMessage);
                if (this.props.onError)
                    this.props.onError(r.error);
            }
        })
    }

    onClose = () => {
        this.setState({
            showPopUp: false
        });
    }

    handleTabChange = (step) => {
        if (this.props.handleTabSelect)
            this.props.handleTabSelect(step);
	}

    renderPrevButton = (prevTabs) => {
        if (this.props.hideNavButtons || !this.props.certificationKey || !prevTabs || prevTabs.length === 0)
            return null;

        const prevStep = prevTabs[prevTabs.length-1].key;

        return (
            <Button id="btnPriorStep" bsStyle="primary" className="btn-sm" onClick={v => this.handleTabChange(prevStep)}>
                <FontAwesomeIcon icon={faArrowCircleLeft} size="lg" color="white" />
            </Button>
        );
    }

    renderNextButton = (nextTabs) => {
        if (this.props.hideNavButtons || !this.props.certificationKey)
            return null;

        let nextStep = null;

        if (nextTabs && nextTabs.length > 0) {
            nextStep = nextTabs[0].key;
        }

        if (nextStep) {
            return (
                <Button id="btnNextStep" bsStyle="primary" className="btn-sm" onClick={v => this.handleTabChange(nextStep)}>
                    <FontAwesomeIcon icon={faArrowCircleRight} size="lg" color="white" />
                </Button>
            );
        }
        
        return null;
    }

    render() {
        let currentStep = ReviewType.CERT_TABS.find(step => step.code === this.props.reviewTypeCode);  
        let currentStepIndex = this.props.setupProps.tabs.findIndex(tab => tab.key === currentStep.tabKey);

        let prevTabs = [];
        let nextTabs = [];
        if (currentStepIndex !== -1) {
            prevTabs = this.props.setupProps.tabs.slice(0,currentStepIndex).filter(tab => !tab.disabled && ReviewType.CERT_TABS.map(c => c.tabKey).includes(tab.key));
            nextTabs = this.props.setupProps.tabs.slice(currentStepIndex+1).filter(tab => !tab.disabled && ReviewType.CERT_TABS.map(c => c.tabKey).includes(tab.key));
        }

        return (
            <div class="btn-toolbar pull-right" style={{ paddingLeft: 10 }}>
                {this.renderPrevButton(prevTabs)}
                {this.props.showCancel &&
                    <Button id="btnCancel" bsStyle="danger" className="btn-sm" onClick={this.handleCancel} disabled={this.props.disableCancel}>
                        <FontAwesomeIcon icon={faTimesCircle} size="lg" color="white" />
                    </Button>
                }
                {this.props.showSave &&
                    <React.Fragment>
                        <Button id="btnSaveChanges"
                            bsStyle="success"
                            className="btn-sm"
                            disabled={this.props.disableSave}
                            onClick={this.handleSave}
                        >
                            <FontAwesomeIcon icon={faSave} size="lg" color="white" />
                            {this.props.savelabel &&
                                <React.Fragment>
                                    &nbsp;{this.props.savelabel}
                                </React.Fragment>
                            }
                        </Button>
                        <IncompleteCommentPopUp
                            ref={(icp) => { this._icp = icp }}
                            certificationKey={this.props.certificationKey}
                            reviewTypeCode={this.props.reviewTypeCode}
                            queueTypeCode={this.props.queueTypeCode}
                            comments={this.props.comments}
                            visible={this.state.showPopUp}
                            onClose={this.onClose}
                            onSave={(form) => { this.onCommentSave(form) }} />
                    </React.Fragment>
                }
                {this.renderNextButton(nextTabs)}
            </div>
        );
    }
}

export default AdminStepToolbar;

// Default properties
AdminStepToolbar.defaultProps = {
    disableCancel: false,
    disableSave: false,
    showSave: false,
    showCancel: false,
    savelabel: null,
    hideNavButtons: false,
}


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/AdminStepToolbar.js